import React from 'react';
import { Field } from 'formik';
import DropZoneV2 from '../../../../components/DropZoneV2/DropZone';

export const DropFileInput = ({ name, label, labelDropZoneOlaClick, maxSizeOlaClick, values, instructions }) => {
  return (
    <div className="form-group form-item">
      <Field
        component={DropZoneV2}
        label={label}
        required
        name={name}
        allowedExt=".pdf"
        values={values}
        maxSize={5000000}
        instructions={instructions}
        labelDropZone={labelDropZoneOlaClick}
        maxSizeOlaClick={maxSizeOlaClick}
      />
    </div>
  );
};
